/**
 * The Spark DS icon (Figma "Spark - DS", Icon page) that stands for each changelog
 * area in What's new. Keys are the `areas` vocabulary in docs/features/catalog.yaml;
 * a highlight shows the icon of its first area. Add an entry here whenever an
 * area is added to the catalog (areaIcons.test.js fails until you do).
 */
export const AREA_ICONS = {
    classification: 'category',
    ner: 'tag',
    summarization: 'description',
    'content-generation': 'sparkles-2',
    playground: 'game',
    'data-preparation': 'database',
    exploration: 'eye',
    inference: 'bolt',
    'model-providers': 'model',
    infrastructure: 'cloud-computing',
    security: 'lock-password-icon',
    ui: 'layout',
};

/** For a highlight without a known area. */
export const FALLBACK_AREA_ICON = 'sparkles-3';

export function areaIcon(areas = []) {
    const known = areas.find((area) => AREA_ICONS[area]);
    return known ? AREA_ICONS[known] : FALLBACK_AREA_ICON;
}
